import { render, staticRenderFns } from "./EditReminderWorkflow.vue?vue&type=template&id=0069abb8&scoped=true&"
import script from "./EditReminderWorkflow.vue?vue&type=script&lang=js&"
export * from "./EditReminderWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./EditReminderWorkflow.vue?vue&type=style&index=0&id=0069abb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0069abb8",
  null
  
)

component.options.__file = "EditReminderWorkflow.vue"
export default component.exports